// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TrialcardEservicesorchestratorV1ModelsResponseModel } from './trialcardEservicesorchestratorV1ModelsResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationResultUpdateDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': TrialcardEservicesorchestratorV1ModelsResponseModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationResultUpdateDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "TrialcardEservicesorchestratorV1ModelsResponseModel"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationResultUpdateDefaultResponse.attributeTypeMap;
    }
}
